type ErrorRecord = Record<string, unknown>;

function isRecord(value: unknown): value is ErrorRecord {
  return typeof value === 'object' && value !== null;
}

function firstMessage(value: unknown): string | undefined {
  if (typeof value === 'string' && value.trim()) return value.trim();
  if (Array.isArray(value)) {
    for (const item of value) {
      const message = firstMessage(item);
      if (message) return message;
    }
  }
  if (isRecord(value)) {
    // Laravel validation errors are keyed by field name, so inspect their
    // values even when the keys are not conventional message properties.
    for (const item of Object.values(value)) {
      const message = firstMessage(item);
      if (message) return message;
    }
  }
  return undefined;
}

/** Extracts a user-facing API message without exposing Angular's transport text. */
export function extractApiError(err: unknown, fallbackKey: string): string {
  const response = isRecord(err) ? err : {};
  const body = isRecord(response['error']) ? response['error'] : response;

  if (response['status'] === 422) {
    const validationMessage = firstMessage(body['errors']);
    if (validationMessage) return validationMessage;
  }

  for (const key of ['message', 'Message', 'error']) {
    if (body === response && response['status'] !== undefined && key !== 'error') continue;
    const message = firstMessage(body[key]);
    if (message) return message;
  }

  // Some API errors wrap the response body under `error` while retaining a
  // top-level message. Check that wrapper without ever reading err.message.
  if (body !== response && response['status'] === undefined) {
    for (const key of ['message', 'Message', 'error']) {
      const message = firstMessage(response[key]);
      if (message) return message;
    }
  }

  return fallbackKey;
}
